module.exports = __webpack_public_path__ + "img/bestellartikel.dfebc952.svg";